export const ru = {
    'add-creatives': {
        one: 'Добавьте формат креатива: {formats} для увеличения аудитории',
        some: 'Добавьте форматы креативов: {formats} для увеличения аудитории',
        many: 'Добавьте форматы креативов: {formats} для увеличения аудитории',
        none: 'Добавьте форматы креативов: {formats} для увеличения аудитории'
    },
    close: 'Закрыть',
    title: 'Добавьте креативы подходящих форматов',
    'title-hint':
        'Рекомендация показывается, потому что в группе не полный охват'
};
